import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Card, TextField, Typography, Alert } from '@mui/material';
import { useUserRegisterMutation } from '../store/docApi';
import { setProfile } from '../store/userSlice';

export default function RegisterProfile() {
    const [username, setUsername] = useState('');
    const [displayName, setDisplayName] = useState('');
    const [error, setError] = useState('');
    const dispatch = useDispatch();
    const [register] = useUserRegisterMutation();
    const userData = useSelector((state) => state.user.userData);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try {
            const result = await register({
                username: username,
                name: displayName
            }).unwrap();
            dispatch(setProfile(result));
            window.location.href = '/';
        } catch (err) {
            if (err.status === 409 || err.originalStatus === 409) {
                setError('This username is already taken. Please choose a different username.');
            } else if (err.data) {
                setError(typeof err.data === 'string' ? err.data : err.data.message || 'Failed to register profile. Please try again.');
            } else {
                setError('Failed to register profile. Please try again.');
            }
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                p: 2
            }}
        >
            <Card sx={{ maxWidth: 400, width: '100%', p: 3 }}>
                <Typography variant="h5" component="h1" gutterBottom align="center">
                    Complete Your Profile
                </Typography>
                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}
                <form onSubmit={handleSubmit}>
                    <TextField
                        fullWidth
                        label="Email"
                        value={userData?.email || ''}
                        margin="normal"
                        InputProps={{
                            readOnly: true,
                        }}
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        fullWidth
                        label="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        margin="normal"
                        required
                        error={error.includes('username')}
                        helperText={error.includes('username') ? 'Please choose a different username' : ''}
                    />
                    <TextField
                        fullWidth
                        label="Display Name"
                        value={displayName}
                        onChange={(e) => setDisplayName(e.target.value)}
                        margin="normal"
                        required
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3 }}
                    >
                        Complete Registration
                    </Button>
                </form>
            </Card>
        </Box>
    );
} 